import { RouterProvider } from "react-router-dom";
import { routes } from "./routes";
import "./App.css";
import Stores from "./stores/Stores";
import { QueryClient, QueryClientProvider } from "react-query";
import { ErrorBoundary } from "react-error-boundary";
import Login from "./pages/Login";
import { HelmetProvider } from "react-helmet-async";
import { ConfigProvider } from "antd";
import ThemeProvider from "./components/ThemeProvider";

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 10000,
      },
    },
  });

  return (
    <HelmetProvider>
      <ErrorBoundary
        FallbackComponent={() => {
          return <Login />
        }}
      >
        <Stores>
          <ThemeProvider>
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: "#2ebd85",
                  colorBgContainer: 'var(--bg-primary)',
                  colorBgElevated: 'var(--bg-secondary)',
                  colorBgLayout: 'var(--bg-primary)',
                  colorBorder: 'var(--border-primary)',
                  colorBorderSecondary: 'var(--border-secondary)',
                  colorText: 'var(--text-primary)',
                  colorTextSecondary: 'var(--text-secondary)',
                  colorTextTertiary: 'var(--text-muted)',
                },
              }}
            >
              <QueryClientProvider client={queryClient}>
                <RouterProvider router={routes} />
              </QueryClientProvider>
            </ConfigProvider>
          </ThemeProvider>
        </Stores>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
